
const routingConfig = (indexName: string): any => ({
    stateToRoute(uiState: any) {
      const indexUiState = uiState[indexName] || {};
      return {
        query: indexUiState.query,
        page: indexUiState.page,
        fees: indexUiState.refinementList?.eventFees,
        region: indexUiState.refinementList?.eventRegions,
        city: indexUiState.refinementList?.['contactInformations.address.city'],
        organizerCity: indexUiState.refinementList?.['organiser.address.city'],
        zip: indexUiState.refinementList?.['contactInformations.address.zip'],
        sort: indexUiState.sortBy,
        category: indexUiState.refinementList?.['categories.name'],
      };
    },
    
    routeToState(routeState: any) {
      return {
        [indexName]: {
          query: routeState.query,
          page: routeState.page,
         
          refinementList: {
            eventFees: routeState.fees,
            eventRegions: routeState.region,
            'contactInformations.address.city': routeState.city,
            'organiser.address.city': routeState.organizerCity,
            'contactInformations.address.zip': routeState.zip,
            'categories.name': routeState.category,
          },
          sortBy: routeState.sort,
        },
      };
    }
  
  });

export default routingConfig;